import React, { forwardRef } from "react";
import styled from "styled-components";
import { space, color, layout, textAlign, position, boxShadow, borderRadius, } from "styled-system";
export const StyledBox = styled.div.withConfig({ displayName: "StyledBox_APC-7311-productShell", componentId: "sc-c6d7k9" })(({ transform }) => ({
    boxSizing: "border-box",
    transform,
}), space, color, layout, borderRadius, boxShadow, textAlign, position);
const Box = forwardRef(function Box(props, ref) {
    return React.createElement(StyledBox, Object.assign({}, props, { ref: ref }));
});
export default Box;
//# sourceMappingURL=Box.js.map